import { render, staticRenderFns } from "./ResourcesDestinationControl.vue?vue&type=template&id=a216266c&"
import script from "./ResourcesDestinationControl.vue?vue&type=script&lang=js&"
export * from "./ResourcesDestinationControl.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesDestinationControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports